import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './Button.scss';
import classNames from 'classnames';

export default class Button extends Component {
    static propTypes = {
        type: PropTypes.string,
        label: PropTypes.string,
        className: PropTypes.string,
        disabled: PropTypes.bool,
        onClick: PropTypes.func
    };

    render() {
        const {label, className, disabled, onClick} = this.props;

        const isSubmitButton = this.props.type === 'submit';
        const type = isSubmitButton ? 'submit' : 'button';

        const isSimpleButton = !this.props.type || this.props.type === 'simple';
        const isDangerButton = this.props.type === 'danger';
        const isCancelButton = this.props.type === 'cancel';
        const isLinkButton = this.props.type === 'link';

        const buttonClassName = classNames(styles.button, className, {
            [styles.disabled]: disabled,
            [styles.simpleButton]: isSubmitButton || isSimpleButton,
            [styles.submitButton]: isSubmitButton,
            [styles.dangerButton]: isDangerButton,
            [styles.cancelButton]: isCancelButton,
            [styles.linkButton]: isLinkButton
        });

        return (
            <input type={type}
                   value={label}
                   disabled={disabled}
                   className={buttonClassName}
                   onClick={onClick}/>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/controls/Button.js